export const boxStyles = {
  alignItems: 'center',
  display: 'flex',
}

export const linkStyles = {
  cursor: 'pointer',
}
